import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { getTenantId } from "../helper";
import { plainToClass } from "class-transformer";
import { IRoleDTO, RoleModel } from "../models/role/Role";
import { IRoleRightCreationRequest } from "../models/role/requests/roleRightCreationRequest";
let RolesModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    let RolesModule = class RolesModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.roles = [];
            this.role = new RoleModel();
            this.pages = [];
        }
        async GetRoles() {
            var url = `${getTenantId()}/role`;
            let { data } = await service.get(url);
            if (data) {
                this.SetRoles(data.roles);
            }
            return [];
        }
        SetRoles(roles) {
            this.roles = roles;
        }
        async AddRole(newrole) {
            var url = `${getTenantId()}/role`;
            let { data } = await service.post(url, newrole);
            if (data) {
                this.SetAddRole(data.role);
                return data;
            }
        }
        SetAddRole(role) {
            this.roles.push(role);
        }
        async UpdateRole(updateRole) {
            var url = `${getTenantId()}/role`;
            let { data } = await service.put(url, updateRole);
            if (data) {
                this.SetUpdateRole(data.role);
                return data;
            }
        }
        SetUpdateRole(role) {
            var that = this;
            var target = that.roles.findIndex((x) => x.id == role.id);
            if (target !== -1) {
                that.roles[target] = plainToClass(RoleModel, role);
            }
            else {
                that.roles.push(plainToClass(RoleModel, role));
            }
            that.roles = [...that.roles];
        }
        async DeleteRole(roleId) {
            var url = `${getTenantId()}/role/` + roleId + `/delete`;
            let { data } = await service.post(url);
            if (data) {
                this.SetDeleteRole(data.roleId);
                return data;
            }
        }
        SetDeleteRole(roleId) {
            const index = this.roles
                .map(function (array) {
                return array.id;
            })
                .indexOf(roleId, 0);
            if (index > -1) {
                this.roles.splice(index, 1);
            }
        }
        async GetRoleRights(roleId) {
            var url = `${getTenantId()}/role/rights?roleId=${roleId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetRoleRights(data.pages);
            }
            return [];
        }
        SetRoleRights(pages) {
            this.pages = pages;
        }
        async SaveRoleRights(value) {
            var url = `${getTenantId()}/role/saveRights`;
            let { data } = await service.post(url, value);
            if (data) {
                return data;
            }
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], RolesModule.prototype, "GetRoles", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], RolesModule.prototype, "SetRoles", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof RoleModel !== "undefined" && RoleModel) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], RolesModule.prototype, "AddRole", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof IRoleDTO !== "undefined" && IRoleDTO) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], RolesModule.prototype, "SetAddRole", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof RoleModel !== "undefined" && RoleModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], RolesModule.prototype, "UpdateRole", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof IRoleDTO !== "undefined" && IRoleDTO) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], RolesModule.prototype, "SetUpdateRole", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], RolesModule.prototype, "DeleteRole", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], RolesModule.prototype, "SetDeleteRole", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], RolesModule.prototype, "GetRoleRights", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], RolesModule.prototype, "SetRoleRights", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof IRoleRightCreationRequest !== "undefined" && IRoleRightCreationRequest) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], RolesModule.prototype, "SaveRoleRights", null);
    RolesModule = __decorate([
        Module({ dynamic: true, store: store, name: "Roles", namespaced: true })
    ], RolesModule);
    return RolesModule;
})();
export const RoleModule = getModule(RolesModule);
